import React, {useEffect, useState} from 'react';
import {contractsUtils} from "../../../../infrastructure/utils/contracts-utils";
import {inject} from 'mobx-react';


export const InitializeController = (settings) => (Component) => inject('ioc')((props) => {
  const [controller, setController] = useState(null);

  contractsUtils.required(settings.controllerType, 'type of controller must be provided when creating widget');

  useEffect(() => {
    if (!controller) {
      const newController = props.ioc.getInstance(settings.controllerType)
      setController(newController);
      newController?.init(props);
    }
  }, [])


  return controller ? <Component {...props} controller={controller}/> : null;
});
